module.exports = __webpack_public_path__ + "img/CheckBox.1540d51c.svg";